import React, { FC } from 'react';
import classNames from 'classnames';
import loadingSpinnerImage from '../images/loading-spinner.png';

type LoadingSpinnerProps = {
  className?: string;
};

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ className }) => {
  return (
    <div className={classNames('flex items-center justify-center w-full', className)}>
      <img className='w-3.5 h-3.5 animate-spin' src={loadingSpinnerImage} alt='loading' />
    </div>
  );
};
